// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"1b569f71","313":"59d0dd7c","320":"59d0dd7c","597":"59d0dd7c","907":"b04ce8c8","917":"59d0dd7c","948":"88204669"}[chunkId] + ".chunk.css";
};